<template>
  <div>
    <div class="refreshVan dc-card" >
      <van-row>
        <van-col span="18">
          <div class="dc-title">
            <span class="name">{{ doctorInfo.DOCTOR_NAME }}</span>
            <span class="tech"> {{ doctorInfo.TECHNICAL }}</span>
            <div class="tech">{{ simpleDate(calcInfo.DOC_DATE) }}</div>

          </div>
        </van-col>
        <van-col span="6">
          <div class="dc-register">
            <div class="title">挂号金额</div>
            <div class="money">{{doctorInfo.FIRST_FEE }}元</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div>
      <van-row class="dg-card">
        <div class="nc-item" v-for="schInfo in schInfos" :key="schInfo.DOCTOR_SCHEDULE_D_ID"
           @click="function(){ currentSchInfo= schInfo}" :class="{active:schInfo== currentSchInfo}">
          <div>{{ schInfo.uiBOOK_TIME }}</div>
        <div>剩余号源: <span>{{ schInfo.SY_QTY }}</span></div>
      </div>
     </van-row>
    </div>

    <div class="bt-card" style="position:fixed; bottom: 20px;width:100%">
      <van-button type="primary" size="large" class="bt-reg" round
                  @click="postRegInfo()">选择</van-button>
    </div>
  </div>
</template>

<script>

import {simpleDate } from "@/common/js/utils";
import {customerBussiness} from "@/service/MpServer";

export default {
  components: {
  },
  name: 'CusDocSch',
  data() {
    return {
      isWinXinClient: false,
      isLoading: false,
      doctorInfo: {},
      calcInfo:{},
      schInfos: [],
      currentSchInfo: {}
    }
  },
  mounted() {
    const app = this;
    this.doctorInfo= JSON.parse(this.$route.query.docInfo);
    this.calcInfo= JSON.parse(this.$route.query.calcInfo);
    this.getDocSch(this.calcInfo.DOCTOR_SCHEDULE_ID);
  },

  methods: {
    simpleDate,

    getDocSch(schid) {
      let _this= this;
      let param = { schId:schid };
      customerBussiness( "DOCTOR_SCHEDULE", "getDocSch", param, function (data) {
        let schlist= JSON.parse(data).Table;
        _this.schInfos= schlist;
        (schlist.length> 0 ) ? _this.currentSchInfo = schlist[0] : {}
      });
    },

    postRegInfo(){
　　　　if (!this.currentSchInfo){
        this.$toast("请先选择预约时段");
        return;
      }

      this.$router.push({path: '/CusDocBook', query: { bookInfo:JSON.stringify({docid: this.doctorInfo.DOCTOR_ID,
          docname: this.doctorInfo.DOCTOR_NAME, doctech:this.doctorInfo.TECHNICAL,
          bookdate:this.calcInfo.DOC_DATE, bookperiod: this.currentSchInfo.PERIOD,
          booktime:this.currentSchInfo.uiBOOK_TIME, fee:this.doctorInfo.FIRST_FEE,
          bookschId:this.currentSchInfo.DOCTOR_SCHEDULE_D_ID}) }});
    }
  }
}
</script>

<style lang="less" scoped >
  @import '../../common/style/mixin';

  body {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif !important;
    font-size: 14px !important;
  }
  .refreshVan{
    overflow: auto;
    background-color: #f9f7f9;


  }
  .dc-card{
    margin-left: 5px;
    margin-top: 10px;
    padding: 10px;
    background: #fffeff;
    box-shadow: 0 0 3px rgba(0,0,0,0.5);
    border-radius: 5px; /* 设置卡片边框圆角 */

    background-image: linear-gradient(135deg, #D4FFE9 0%, #FFFFFF 54%, #E5FFF2 100%);
    border-radius: 20px;
    border-radius: 20px;
  }
  .dc-title{
    height: 28px;
    line-height: 28px;
    .name{
      font-size: 18px;
      font-weight: 600;
    }
    .name{
      font-size: 20px;
      font-weight: 600;
    }
    .tech{
      font-size: 16px;
      font-weight: 600;
      color: #999999;
    }
    .title{
      font-size: 13px;
      margin-left: 5px;
    }
  }
  .dc-item{
    height: 18px;
    line-height: 18px;
    font-weight: 500;
    font-size: 13px;
  }
  .dc-register{
    height: 80px;
    display: flex;
    align-items: center;
    flex-flow: row wrap;
    align-content:center;

    .title{
      font-size: 16px;
      color: #999999;
    }
    .money{
      padding: 2px 0px 0px 5px;
      color: #FF6B01;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .dg-card {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .nc-item {
      background: #FFFFFF;
      border-radius: 10px;
      margin: 6px 8px 0px 8px;

      padding: 10px;
      width: 40%;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.5); /* 设置卡片阴影 */
    }

    .active {
      background-color: #01BD5D;
      color: #FFFFFF;
    }

    .bt-card {
      position: fixed;
      bottom: 20px;
      align-content: center;
      .bt-reg{
      }
    }
  }

</style>
